import { createFileRoute, Link } from "@tanstack/react-router";
import { EditablePageShell, useSitePage } from "@/components/site/EditablePageShell";
import { pageQueryOptions } from "@/lib/pages.functions";
import packagingOpen from "@/assets/packaging-open.jpg";
import { SHARE_IMAGES } from "@/lib/share-images";

export const Route = createFileRoute("/gifts")({
  loader: ({ context }) => context.queryClient.ensureQueryData(pageQueryOptions("gifts")),
  head: ({ loaderData }) => ({
    meta: [
      { title: loaderData?.title || "Golf Gifts — Glow Long Golf" },
      { name: "description", content: loaderData?.meta_description || "The most-remembered golf gift of the season. Premium matte-black packaging, six brilliant colors." },
      { property: "og:title", content: loaderData?.title || "Golf Gifts — Glow Long Golf" },
      { property: "og:description", content: loaderData?.meta_description || "The most-remembered golf gift of the season. Premium matte-black packaging, six brilliant colors." },
      { property: "og:url", content: "https://glowlonggolf.com/gifts" },
      { property: "og:image", content: SHARE_IMAGES.flatLayGrid },
      { name: "twitter:image", content: SHARE_IMAGES.flatLayGrid },
    ],
    links: [{ rel: "canonical", href: "https://glowlonggolf.com/gifts" }],
  }),

  errorComponent: ({ error }) => <div className="p-8 text-sm text-destructive" role="alert">{error.message}</div>,
  notFoundComponent: () => <div className="p-8 text-sm text-muted-foreground">Not found.</div>,
  component: GiftsPage,
});

function GiftsPage() {
  const page = useSitePage("gifts");
  const img = page?.hero_image_url || packagingOpen;
  return (
    <EditablePageShell
      slug="gifts"
      defaults={{ eyebrow: "Gifts", title: "The golf gift people actually remember", lead: "Six glowing colors, premium matte-black packaging, gift-ready." }}
    >
      <section className="mx-auto grid max-w-6xl gap-10 px-4 py-12 sm:px-6 md:grid-cols-2 lg:px-8">
        <div className="overflow-hidden rounded-3xl border border-border bg-card"><img src={img} alt="Gift-ready packaging" className="h-full w-full object-cover" loading="lazy" /></div>
        <div className="space-y-4 text-muted-foreground">
          <h2 className="font-display text-2xl font-semibold text-foreground">Why it makes a great gift</h2>
          <ul className="ml-5 list-disc space-y-2">
            <li>Six unique colors — the recipient picks a favorite or shares with friends.</li>
            <li>Premium black mailer doubles as gift packaging — no wrapping required.</li>
            <li>$17.99 is a great stocking-stuffer price point.</li>
            <li>Works for any golfer: serious, casual, beginners.</li>
          </ul>
          <Link to="/shop" className="inline-flex rounded-full bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground shadow-glow hover:opacity-90">Shop gift packs</Link>
        </div>
      </section>
    </EditablePageShell>
  );
}
